// extracted by mini-css-extract-plugin
module.exports = {"modalsH5":"modals_modalsH5__NhILl"};